import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUp = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 11,
	viewBox: "0 0 14 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0.647996 7L0 6.51109L7 0L14 6.51109L13.352 7L7 1.09164L0.647996 7Z",
		fill: "black"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M0.647996 11L0 10.5111L7 4L14 10.5111L13.352 11L7 5.09164L0.647996 11Z",
		fill: "black"
	})]
});
export default SvgUp;
